import Cookies from 'js-cookie'
/**
 * Cookie storage class
 * @description Cookie storage class with the domain from the environment variables or localhost
 * Save the cookies for the cognito user pools token provider
 * This token can be readable from ix-admin app for the graphql requests
 */
export class CookieStorage {
  constructor() {
    this.domain = process.env.VUE_APP_COOKIE_DOMAIN || 'localhost'
  }
  /**
   * Set the item in the cookie
   * @param {*} key - The key of the item
   * @param {*} value - The value of the item
   * @returns
   */
  setItem(key, value) {
    Cookies.set(key, value, {
      expires: 365,
      domain: this.domain,
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'lax',
    })
    return value
  }
  /**
   * Get the item from the cookie
   * @param {*} key - The key of the item
   * @returns The value of the item
   */
  getItem(key) {
    return Cookies.get(key) || null
  }
  /**
   * Remove the item from the cookie
   * @param {*} key - The key of the item
   */
  removeItem(key) {
    Cookies.remove(key, { domain: this.domain })
  }
  /**
   * Clear the cookie
   */
  clear() {
    const allCookies = Cookies.get()
    Object.keys(allCookies).forEach((cookieName) => {
      if (cookieName.includes('CognitoIdentityServiceProvider')) {
        Cookies.remove(cookieName, { domain: this.domain })
      }
    })
  }
}
